/**
 * Format role name for display
 * Converts underscore-separated role names to Title Case
 * 
 * @param {string} role - Role string from backend (e.g., "company_admin")
 * @returns {string} - Formatted role for display (e.g., "Company Admin")
 * 
 * @example
 * formatRoleName('company_admin') // → "Company Admin"
 * formatRoleName('branch_user')   // → "Branch User"
 * formatRoleName('PAYROLL_ADMIN') // → "Payroll Admin"
 */
export const formatRoleName = (role) => {
  if (!role) return '';
  
  // Handle null, undefined, or empty string
  if (typeof role !== 'string') return String(role || '');
  
  return role
    .split('_')
    .map(word => {
      // Convert to lowercase first, then capitalize first letter
      const lowerWord = word.toLowerCase();
      return lowerWord.charAt(0).toUpperCase() + lowerWord.slice(1);
    })
    .join(' ');
};

